import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';

const useAppreciationsConfig = () => {
  const [appreciationsResultat, setAppreciationsResultat] = useState([]);
  const [appreciationsNote, setAppreciationsNote] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Charger toutes les appréciations
  const charger = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const result = await api.configAppreciations.getAll();

      if (result.success) {
        const data = result.data || [];
        setAppreciationsResultat(data.filter(a => a.type === 'resultat'));
        setAppreciationsNote(data.filter(a => a.type === 'note'));
      } else {
        setError(result.error || 'Erreur chargement');
      }
    } catch (err) {
      console.error('❌ Hook useAppreciationsConfig - Erreur:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { charger(); }, [charger]);

  // Créer
  const creer = async (data) => {
    const result = await api.configAppreciations.create(data);
    if (result.success) await charger();
    return result;
  };

  // Modifier
  const modifier = async (id, data) => {
    const result = await api.configAppreciations.update(id, data);
    if (result.success) await charger();
    return result;
  };

  // Supprimer
  const supprimer = async (id) => {
    const result = await api.configAppreciations.delete(id);
    if (result.success) await charger();
    return result;
  };

  // Réinitialiser
  const reinitialiser = async (type) => {
    const result = await api.configAppreciations.reset(type);
    if (result.success) await charger();
    return result;
  };

  // Helper: obtenir l'appréciation pour une moyenne donnée
  const getAppreciation = useCallback((moyenne, type = 'resultat') => {
    const config = type === 'resultat' ? appreciationsResultat : appreciationsNote;
    const moy = parseFloat(moyenne) || 0;
    return config.find(a => moy >= parseFloat(a.note_min) && moy <= parseFloat(a.note_max)) 
      || { libelle: '-', couleur: 'bg-gray-100 text-gray-500' };
  }, [appreciationsResultat, appreciationsNote]);

  return {
    appreciationsResultat,
    appreciationsNote,
    loading,
    error,
    charger,
    creer,
    modifier,
    supprimer,
    reinitialiser,
    getAppreciation
  };
};

export default useAppreciationsConfig;